import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout-app')({
  ssr: false,
  beforeLoad: async () => {
    // Guard all /app routes - check session client-side only
    if (typeof window === 'undefined') return;

    // Supabase Auth sends failed OAuth/OTP redirects here as query params
    // (e.g. /app?error=invalid_request&error_code=bad_oauth_state&...).
    // Forward them to /auth as a friendly message instead of falling through
    // to the session check below, which would otherwise discard them.
    const params = new URLSearchParams(window.location.search);
    const authError = params.get('error');
    if (authError) {
      throw redirect({
        to: '/auth',
        search: {
          error_code: params.get('error_code') ?? authError,
          error_description: params.get('error_description') ?? undefined,
        },
      });
    }

    const { supabase } = await import('@upcaret/supabase-types/client');
    const { data, error } = await supabase.auth.getSession();

    if (error || !data.session?.user) {
      const redirectTo = `${window.location.pathname}${
        window.location.search ?? ''
      }`;
      throw redirect({
        to: '/auth',
        search: { redirect: redirectTo },
      });
    }
  },
});
